import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { api } from "@/lib/api";
import { ArrowRight, MagnifyingGlass } from "@phosphor-icons/react";
import Seo from "@/components/Seo";

export default function Articles() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/articles", { params: q ? { q } : {} }).then((r) => setItems(r.data)); }, [q]);
  return (
    <Page>
      <Seo title="Articles · The MindDhara Journal" description="Long-form pieces on therapy, cognitive performance and psychology careers from the MindDhara team." />
      <section className="md-section md-page-hero" data-testid="articles-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">Articles</div>
          <h1 className="text-5xl md:text-6xl font-serif mb-6">Read, learn, return</h1>
        </div>
      </section>
      <section className="md-section pt-0">
        <div className="md-container">
          <div className="relative max-w-xl mb-10 mx-auto">
            <MagnifyingGlass size={18} className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: "var(--md-text-muted)" }} />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search articles…" className="md-input pl-11" data-testid="articles-search" />
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((a) => (
              <Link key={a.id} to={`/articles/${a.slug}`} className="md-card md-card-hover" data-testid={`article-card-${a.slug}`}>
                {a.cover_url && <img src={a.cover_url} alt={a.title} className="w-full h-44 object-cover rounded-lg mb-4" />}
                <div className="md-label-eyebrow text-[10px]">{a.category}</div>
                <h3 className="font-serif text-xl mt-2">{a.title}</h3>
                <p className="text-sm mt-2" style={{ color: "var(--md-text-soft)" }}>{a.excerpt}</p>
                <p className="text-xs mt-4 flex items-center gap-2 flex-wrap" style={{ color: "var(--md-text-muted)" }} data-testid={`article-meta-${a.slug}`}>
                  <span>By {a.author}</span>
                  {a.created_at && (
                    <>
                      <span aria-hidden>·</span>
                      <time dateTime={a.created_at}>
                        {new Date(a.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                      </time>
                    </>
                  )}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Page>
  );
}
